<!-- 
The view responsible for creating a trade.

the fileds we need are as follows,

Who did we send this to  ,
this should be some type of drop down,.
with fetcxhing ability so we can search,
but it should be done in a way we only record the ID?

The product being sold
the quantity of the product being sold.
who are we selling to ?
-->
<template>
	<div id="createTransactionView">
		<form class="formPadding">
			<div class="md:flex md:items-center mb-6">
				<div class="md:w-1/3">
					<label class="block text-black md:text-right mb-1 md:mb-0 pr-4">
						Transaction type
					</label>
				</div>

				<div class="md:w-1/3">
					<vue-multiselect
						placeholder="Select the type of transaction that is being added"
						label="label"
						:options="transactionTypeList"
						:searchable="true"
						@select="onTransactionTypeChanged"
						v-model="formData.TransactionType"
					>
						<template slot="option" slot-scope="eachTxType">
							<span>
								<div>{{ eachTxType.option.label }}</div>
								<div class="text-xs italic " v-if="eachTxType.option.tip">
									{{ eachTxType.option.tip }}
								</div>
							</span>
						</template>
					</vue-multiselect>
				</div>
			</div>

			<div class="md:flex md:items-center mb-6">
				<div class="md:w-1/3">
					<label class="block text-black md:text-right mb-1 md:mb-0 pr-4">
						Seller's Certificate
					</label>
				</div>

				<div class="md:w-1/3">
					<vue-multiselect
						placeholder="Select the seller's certificate"
						label="label"
						:options="sellersCertificatesList"
						:filterable="false"
						@select="onSellersCertificateChanged"
						v-model="formData.SellersCertificate"
						:disabled="isSellersCertificateFieldDisabled"
					>
						<template slot="option" slot-scope="eachSellersCert">
							<span>
								<div>{{ eachSellersCert.option.label }}</div>
								<div class="text-xs italic " v-if="eachSellersCert.option.SellersCertificate.tip">
									{{ eachSellersCert.option.SellersCertificate.tip }}
								</div>
							</span>
						</template>
					</vue-multiselect>
				</div>
			</div>

			<div class="md:flex md:items-center mb-6">
				<div class="md:w-1/3">
					<label class="block text-black md:text-right mb-1 md:mb-0 pr-4">
						Sold as
					</label>
				</div>

				<div class="md:w-1/3">
					<vue-multiselect
						placeholder="Select the type of transaction that is being added"
						:options="soldAsList"
						label="label"
						@select="onSoldAsChanged"
						v-model="formData.SoldAs"
					>
					</vue-multiselect>
				</div>
			</div>

			<div class="md:flex md:items-center mb-6">
				<div class="md:w-1/3"></div>

				<div class="md:w-1/3">
					<p-checkbox
						class="p-svg p-curve"
						style="float:left;"
						color="success"
						v-model="formData.confirmGorwRegion"
						:disabled="isCertifyCheckboxDisabled"
					>
						<svg slot="extra" class="svg svg-icon" viewBox="0 0 20 20">
							<path
								d="M7.629,14.566c0.125,0.125,0.291,0.188,0.456,0.188c0.164,0,0.329-0.062,0.456-0.188l8.219-8.221c0.252-0.252,0.252-0.659,0-0.911c-0.252-0.252-0.659-0.252-0.911,0l-7.764,7.763L4.152,9.267c-0.252-0.251-0.66-0.251-0.911,0c-0.252,0.252-0.252,0.66,0,0.911L7.629,14.566z"
								style="stroke: white;fill:white"
							></path>
						</svg>
						I certify this product was produced or processed in the U.S. or its territories
					</p-checkbox>
				</div>
			</div>

			<div>
				<div class="md:flex md:items-center mb-6">
					<div class="md:w-1/3">
						<label class="block text-black md:text-right mb-1 md:mb-0 pr-4">
							{{ formData.TransactionType.label == "Sale" ? "Buyer" : "Seller" }}
							<br />
							<span class="labelSpan">
								{{
								formData.TransactionType.label == "Sale"
									? "( Who you sold to )"
									: "( Who you bought from )"
								}}
							</span>
						</label>
					</div>

					<div class="md:w-1/3">
						<vue-multiselect
							placeholder="Type the NOP operation ID or operation name to begin search"
							:options="buyersList"
							@select="onNOPOperationChange"
							@search-change="searchNOPOperations"
							:internalSearch="false"
							label="label"
							v-model="formData.transactionOtherParty"
						>
							<template slot="option" slot-scope="eachOperation">
								<span>
									<div class="pb-1">{{ eachOperation.option.opIdNameLabel }}</div>
									<div class="pb-1">{{ eachOperation.option.countryLabel }}</div>
									<div class="borderBtmTxOtherPty"></div>
								</span>
							</template>
						</vue-multiselect>
					</div>
				</div>

				<div class="md:flex md:items-center mb-6">
					<div class="md:w-1/3">
						<label class="block text-black md:text-right mb-1 md:mb-0 pr-4">
							Product
						</label>
					</div>

					<div class="md:w-1/3">
						<vue-multiselect
							placeholder="Type the product name to begin search"
							:options="productLookupOptions"
							@select="onProductChange"
							label="label"
							v-model="formData.Product"
							:filterable="false"
						>
						</vue-multiselect>
					</div>
				</div>

				<div class="md:flex md:items-center mb-6">
					<div class="md:w-1/3">
						<label class="block text-black md:text-right mb-1 md:mb-0 pr-4">
							Quantity
						</label>
					</div>

					<div class="md:w-1/3 flex">
						<div class="md:w-3/5 pr-1">
							<input @change="onQuantityChange" placeholder="Quantity" v-model="Quantity" />
						</div>

						<div class="md:w-2/5">
							<vue-multiselect
								label="label"
								placeholder="Weight"
								:options="weightUnitsList"
								v-model="formData.QuantityUnit"
								@select="onQuantityUnitChange"
							>
							</vue-multiselect>
						</div>
					</div>
				</div>

				<div class="md:flex md:items-center mb-6">
					<div class="md:w-1/3">
						<label class="block text-black md:text-right mb-1 md:mb-0 pr-4">
							Date
						</label>
					</div>

					<div class="md:w-1/3 datePickerDiv">
						<v-datepicker
							v-model="formData.transactionDate"
							:clear-button="true"
							placeholder="Date of title transfer"
							@input="onTxDateChanged"
						></v-datepicker>
					</div>
				</div>
			</div>
		</form>

		<div class="pt-4 mt-0 pb-6 flex">
			<div class="invisible md:w-1/5 md:visible"></div>
			<div class="sm:w-full md:w-3/5">
				<div class="bg-black pt-4 pb-10 text-white">
					{{
					!this.addressFound
						? "Please select the trade location from the map. By clicking the location on the map, or by searching for the location."
						: this.addressFound
					}}
				</div>

				<mapbox
					:accessToken="mapOptions.accessToken"
					:map-options="mapOptions"
					@map-init="mapInitialized"
					:nav-control="{ show: true, position: 'bottom-right' }"
					:scale-control="{ show: true, position: 'bottom-left' }"
					:fullscreen-control="{ show: false, position: 'top-left' }"
				>
				</mapbox>
			</div>
		</div>

		<button @click="onSubmitForm">
			Submit
		</button>
	</div>
</template>

<script>
import asyncRequest from "./../../utils/asyncRequest.js";
import Mapbox from "mapbox-gl-vue";
import MapboxGeocoder from "@mapbox/mapbox-gl-geocoder";
import axios from "axios";
import turfCenter from "@turf/center";
import { toGramsFrom } from "../../utils/weightConverter.js";

var _get = require("lodash.get");

export default {
	name: "CreateTradeView",
	created() {
		this.findAllProducts();

		//First go through our matrix thinggy and essemble a unique list of stuff to show our user for tx type
		this.transactionTypeList = [];
		var t = this.TransactionInfoMatrix[0].TransactionType;
		this.transactionTypeList = [t];

		//Find unique txTypes and put them in to the tcTypeList
		for (var i = 0; i < this.TransactionInfoMatrix.length; i++) {
			var found = false;
			for (var j = 0; j < this.transactionTypeList.length; j++) {
				found = false;
				if (this.TransactionInfoMatrix[i].TransactionType.label == this.transactionTypeList[j].label) {
					break;
				} else {
					found = true;
				}
			}
			if (found) {
				this.transactionTypeList.push(this.TransactionInfoMatrix[i].TransactionType);
			}
		}
		//Give a default value to tx if its not set
		if (!this.formData.TransactionType) {
			this.formData.TransactionType = this.transactionTypeList[0];
		}

		//Call the functions to filter seller certs.
		this.onTransactionTypeChanged(this.transactionTypeList[0]);
	},
	data() {
		return {
			reasonFiledIsDisabled: true,
			mapOptions: {
				accessToken:
				"pk.eyJ1IjoibWFsaWtmb3V6ZSIsImEiOiJjanF6ZHU2ZHowZDF1NDNsazl6dWF2OXoxIn0.7ZmKrMF5juUPgm2QS6RpsQ",
				//style: "mapbox://styles/malikfouze/cjsos1ccq219e1gkbdn64hk9p",//streets
				style: "mapbox://styles/malikfouze/cjsoryqsn0ck51fqvt858coqp", //black
				//style: "mapbox://styles/malikfouze/cjqzfa3r72dku2sljvm9d0sks", //sat
				//center: [-106.39640808105469, 52.276245566098574],
				center: [-106.657807, 52.136847], //Sunrise building
				zoom: 13
			},
			//This thing defines what our drop downs are supposed to show. They are progessively filtered as the user fills the form.
			//Yes we do implement the ability to clear previous filters if a filter higherup the chain get cleared.
			TransactionInfoMatrix: [
				{
					SellersCertificate: { specialLabel: "NOP", label: "NOP", tip: "" },
					SoldAs: { label: "NOP", value: "NOP", tip: "" },
					TransactionType: { label: "Sale", tip: "(Most common)" },
					AgreementTypeWithUsdaNOP: "",
					WhoShouldCreateTransaction: "Seller",
					EU_COI: "false",
					TM11: "false",
					NOP_Import_Certificates: "false",
					NAQS: "false"
				},
				{
					SellersCertificate: { specialLabel: "NOP", label: "NOP", tip: "" },
					SoldAs: { label: "COR", value: "COR", tip: "" },
					TransactionType: { label: "Sale", tip: "(Most common)" },
					AgreementTypeWithUsdaNOP: "Equivalence Errangement",
					WhoShouldCreateTransaction: "Seller",
					EU_COI: "false",
					TM11: "false",
					NOP_Import_Certificates: "false",
					NAQS: "false"
				},
				{
					SellersCertificate: { label: "NOP", tip: "" },
					SoldAs: { label: "NOP - EU", value: "EU", tip: "" },
					TransactionType: { label: "Sale", tip: "(Most common)" },
					AgreementTypeWithUsdaNOP: "Equivalence Errangement",
					WhoShouldCreateTransaction: "Seller",
					EU_COI: "true ",
					TM11: "false",
					NOP_Import_Certificates: "false",
					NAQS: "false"
				},
				{
					SellersCertificate: { specialLabel: "NOP", label: "NOP", tip: "" },
					SoldAs: { label: "NOP - JAS", value: "JAS", tip: "" },
					TransactionType: { label: "Sale", tip: "(Most common)" },
					AgreementTypeWithUsdaNOP: "Equivalence Errangement",
					WhoShouldCreateTransaction: "Seller",
					EU_COI: "false",
					TM11: "true ",
					NOP_Import_Certificates: "false",
					NAQS: "false"
				},
				{
					SellersCertificate: { specialLabel: "NOP", label: "NOP", tip: "" },
					SoldAs: { label: "NOP - Korea", value: "Korea", tip: "" },
					TransactionType: { label: "Sale", tip: "(Most common)" },
					AgreementTypeWithUsdaNOP: "Equivalence Errangement",
					WhoShouldCreateTransaction: "Seller",
					EU_COI: "false",
					TM11: "false",
					NOP_Import_Certificates: "false",
					NAQS: "true"
				},
				{
					SellersCertificate: { specialLabel: "Swiss Organic Regulation", label: "NOP", tip: "" },
					SoldAs: { label: "Swiss Organic Regulation", value: "Swiss Organic Regulation", tip: "" },
					TransactionType: { label: "Sale", tip: "(Most common)" },
					AgreementTypeWithUsdaNOP: "Equivalence Errangement",
					WhoShouldCreateTransaction: "Seller",
					EU_COI: "true ",
					TM11: "false",
					NOP_Import_Certificates: "false",
					NAQS: "false"
				},
				{
					SellersCertificate: { specialLabel: "NOP", label: "NOP", tip: "" },
					SoldAs: { label: "Taiwan", value: "Taiwan", tip: "" },
					TransactionType: { label: "Sale", tip: "(Most common)" },
					AgreementTypeWithUsdaNOP: "Trade Arrangement",
					WhoShouldCreateTransaction: "Seller",
					EU_COI: "false",
					TM11: "true ",
					NOP_Import_Certificates: "false",
					NAQS: "false"
				},
				{
					SellersCertificate: {
						specialLabel: "NOP",
						label: "NOP",
						tip: "(Issued anwhere except India, Israel, or New Zealand)"
					},
					SoldAs: { label: "NOP", value: "NOP", tip: "" },
					TransactionType: { label: "Purchase", tip: "(Less common)" },
					AgreementTypeWithUsdaNOP: "",
					WhoShouldCreateTransaction: "Seller",
					EU_COI: "false",
					TM11: "false",
					NOP_Import_Certificates: "false",
					NAQS: "false"
				},
				{
					SellersCertificate: { specialLabel: "NOPIndia", label: "India", tip: "(Issued in India)" },
					SoldAs: { label: "NOP", value: "NOP", tip: "" },
					TransactionType: { label: "Purchase", tip: "(Less common)" },
					AgreementTypeWithUsdaNOP: "Recognition Agreement",
					WhoShouldCreateTransaction: "?",
					EU_COI: "false",
					TM11: "false",
					NOP_Import_Certificates: "false",
					NAQS: "false"
				},
				{
					SellersCertificate: { specialLabel: "NOPIsrael", label: "Israel", tip: "(Issued in Israel)" },
					SoldAs: { label: "NOP", value: "NOP", tip: "" },
					TransactionType: { label: "Purchase", tip: "(Less common)" },
					AgreementTypeWithUsdaNOP: "Recognition Agreement",
					WhoShouldCreateTransaction: "?",
					EU_COI: "false",
					TM11: "false",
					NOP_Import_Certificates: "false",
					NAQS: "false"
				},
				{
					SellersCertificate: { specialLabel: "NOPNewZealand", label: "NZ", tip: "(Issued in New Zealand)" },
					SoldAs: { label: "NOP", value: "NOP", tip: "" },
					TransactionType: { label: "Purchase", tip: "(Less common)" },
					AgreementTypeWithUsdaNOP: "Recognition Agreement",
					WhoShouldCreateTransaction: "?",
					EU_COI: "false",
					TM11: "false",
					NOP_Import_Certificates: "false",
					NAQS: "false"
				},
{
					SellersCertificate: { specialLabel: "COR", label: "COR", tip: "" },
					SoldAs: { label: "NOP", value: "NOP", tip: "" },
					TransactionType: { label: "Purchase", tip: "(Less common)" },
					AgreementTypeWithUsdaNOP: "Equivalence Arrangement",
					WhoShouldCreateTransaction: "Buyer",
					EU_COI: "false",
					TM11: "false",
					NOP_Import_Certificates: "false",
					NAQS: "false"
				},
				{
					SellersCertificate: { specialLabel: "EU", label: "NOP-EU", tip: "" },
					SoldAs: { label: "NOP", value: "NOP", tip: "" },
					TransactionType: { label: "Purchase", tip: "(Less common)" },
AgreementTypeWithUsdaNOP: "Equivalence Arrangement",
					WhoShouldCreateTransaction: "Buyer",
					EU_COI: "false",
					TM11: "false",
					NOP_Import_Certificates: "true",
					NAQS: "false"
				},
				{
					SellersCertificate: { specialLabel: "JAS", label: "JAS", tip: "" },
					SoldAs: { label: "NOP", value: "NOP", tip: "" },
					TransactionType: { label: "Purchase", tip: "(Less common)" },
					AgreementTypeWithUsdaNOP: "Equivalence Arrangement",
					WhoShouldCreateTransaction: "Buyer",
					EU_COI: "false",
					TM11: "false",
					NOP_Import_Certificates: "true",
					NAQS: "false"
				},
				{
					SellersCertificate: { specialLabel: "Korea", label: "Korea", tip: "" },
					SoldAs: { label: "NOP", value: "NOP", tip: "" },
					TransactionType: { label: "Purchase", tip: "(Less common)" },
					AgreementTypeWithUsdaNOP: "Equivalence Arrangement",
					WhoShouldCreateTransaction: "Buyer",
					EU_COI: "false",
					TM11: "false",
					NOP_Import_Certificates: "true",
					NAQS: "false"
				},
				{
					SellersCertificate: {
						specialLabel: "Swiss Organic Regulation",
						label: "Swiss Organic Regulation",
						tip: ""
					},
					SoldAs: { label: "NOP", value: "NOP", tip: "" },
					TransactionType: { label: "Purchase", tip: "(Less common)" },
					AgreementTypeWithUSDANOP: "Equivalence Errangement",
					WhoShouldCreateTransaction: "Buyer",
					EU_COI: "false",
					TM11: "false",
					NOP_Import_Certificates: "true",
					NAQS: "false"
				}
			],
			sellersCertificatesList: [],
			soldAsList: [],
			transactionTypeList: [],
			weightUnitsList: this.$store.state.globalSettings.WEIGHTS_LIST,
			productLookupOptions: [],
			buyersList: [],
			//This var changes depending on the tx type selected. Buyer when neg-trade Seller when trade
			initedMap: {},
			Draw: {},
			Map: {},
			Geocoder: null,
			locationMarker: null,
			foundAreaMarkerLayerID: "",

			Quantity: "",
			addressFound: null,
			addressFoundGPS: null,
			TransactionType: "",
			transactionOtherParty: "Seller/Buyer",
			tx: "Seller",

			formData: {
				TransactionType: "",
				SellersCertificate: "",
				SoldAs: "",
				transactionOtherParty: "",
				Product: "",
				QuantityUnit: { label: "Metric Tonne", value: "Metric Tonne" },
				PKUSDANOPID: 0,
				Quantity: 0,
				Date: null,
				transactionDate: null,
				TransactionLocation: "",
				ProductID: 0,
				TransactionToNOPID: 0,
				TransactionFromNOPID: 0,
				confirmGorwRegion: null
			}
		};
	},
	computed: {
		isRequireFieldDisabled() {
			if (this.TransactionType == "Purchase") {
				return false;
			}
			return true;
		},
		isSellersCertificateFieldDisabled() {
			if (this.sellersCertificatesList.length == 1) {
				return true;
			}
			return false;
		},
		isCertifyCheckboxDisabled() {
			var v = _get(this.formData.SoldAs, "SoldAs.value", "");

			if (v == "JAS" || v == "EU" || v == "Taiwan") {
				return false;
			}
			return true;
		}
	},
	methods: {
		onTransactionTypeChanged(dataIn) {
			if (!dataIn) {
				return;
			}

			//Find the from list that is matching the selected tx type and put it in a list
			this.sellersCertificatesList = [];
			for (var i = 0; i < this.TransactionInfoMatrix.length; i++) {
				if (this.TransactionInfoMatrix[i].TransactionType.label == dataIn.label) {
					var t = JSON.parse(JSON.stringify(this.TransactionInfoMatrix[i]));
					//we need to do a unique test too :'(
					//Find dups
					var dupFound = false;
					for (var j = 0; j < this.sellersCertificatesList.length; j++) {
						if (this.sellersCertificatesList[j].SellersCertificate.label == t.SellersCertificate.label) {
							dupFound = true;
							break;
						}
					}
					if (!dupFound) {
						//Need to do this coz
						t.label = t.SellersCertificate.label;
						this.sellersCertificatesList.push(t);
						dupFound = false;
					}
				}
			}
			//a requirement
			//default
			if (this.sellersCertificatesList.length == 1) {
				this.formData.SellersCertificate = this.sellersCertificatesList[0];
			}

			if (this.formData.SellersCertificate) {
				//Incase there is a value given for the sellersCertificate then we need to populate our sold as list
				this.onSellersCertificateChanged(this.formData.SellersCertificate);
			}

			//Makesure to clear everything that depends on the value selected here
		},
		onSellersCertificateChanged(sellerCertSelected) {
			if (!sellerCertSelected) {
				return;
			}

			//This time we are looking at the to field to figure which of them are valid TO filds that match our
			// from fields in the matrix thinggy .
			//We cant use the previously built list, coz we got rid of dups :( so
			//We cna ofcourse mark dups, unmark them and use them ... jesus no! so...
			this.soldAsList = [];
			for (var i = 0; i < this.TransactionInfoMatrix.length; i++) {
				if (
					this.TransactionInfoMatrix[i].SellersCertificate.label ==
						sellerCertSelected.SellersCertificate.label &&
						this.TransactionInfoMatrix[i].TransactionType.label == sellerCertSelected.TransactionType.label
				) {
					var t = JSON.parse(JSON.stringify(this.TransactionInfoMatrix[i]));
					//we need to do a unique test too :'(
					var dupFound = false;
					for (var j = 0; j < this.soldAsList.length; j++) {
						if (this.soldAsList[j].SoldAs.label == t.label) {
							dupFound = true;
							break;
						}
					}
					if (!dupFound) {
						//Need to do this coz, fuck vue-select... :S
						t.label = t.SoldAs.label;
						this.soldAsList.push(t);
						dupFound = false;
					}
				}
			}

			this.formData.SoldAs = "";
		},
		//If normal trade we treat the buyer (TO) party as the other nop. While neg trade means the other guy is our seller (FROM).
		onNOPOperationChange(dataIn) {
			if (this.formData.TransactionType == "normal_trade") {
				this.formData.TransactionToNOPID = dataIn.value;
} else if (this.formData.TransactionType == "negative_trade") {
				this.formData.TransactionFromNOPID = dataIn.value;
			}
		},
		onProductChange(dataIn) {
			this.formData.ProductID = dataIn.value;
		},
		onQuantityChange(e) {
			this.formData.Quantity = e.target.value;
		},
		onQuantityUnitChange(dataIn) {
			this.formData.QuantityUnit = dataIn.value;
		},
		onTxDateChanged(dataIn) {
			this.formData.Date = dataIn;
		},
		onSubmitForm() {
			var URL = this.$store.state.urls.POST_ADD_NEW_TRANSACTION;
			var decimalPoints = 9;

			var quantityInGrams = Number(_get(this.formData, "Quantity", 0));
			quantityInGrams = toGramsFrom(
				this.formData.QuantityUnit.value,
				quantityInGrams,
				decimalPoints
			);

			console.log(quantityInGrams)

			quantityInGrams = Number(quantityInGrams);

			if (!this.isCertifyCheckboxDisabled && !this.formData.confirmGorwRegion) {
				alert(
					"Please confirm the product was grown in the US. or its territories. "
				);
				return;
			}

			var dataToPost = {
				TransactionType: _get(this.formData, "TransactionType.label", "Sale"),
				SellersCertificateType: _get(
					this.formData,
					"SellersCertificate.SellersCertificate.specialLabel",
					"NOP"
				),
				SoldAsCertificateType: _get(this.formData, "SoldAs.SoldAs.value", ""),
				TransactionOtherPartyAllOperationsID: _get(this.formData, "transactionOtherParty.AllOperationsID", 0),
				ProductID: _get(this.formData, "Product.value", 0),
				QuantityInGrams: quantityInGrams,
				TransactionactionDate: _get(this.formData, "Date", ""),
				AddressLabel: this.addressFound,
				//Send lon lat as strings
				TransactionLocationGPSLon: _get(this.addressFoundGPS, "lon", "") + "",
				TransactionLocationGPSLat: _get(this.addressFoundGPS, "lat", "") + ""
			};

			asyncRequest.ServerAPI({
				progressBarObj: this.$Progress,
				method: "POST",
				api: URL,
				postData: dataToPost,
				onSuccessCallback: dataIn => {
					this.onSuccessfulSubmitForm(dataIn);
				},
				flags: asyncRequest.M_FAIL | asyncRequest.M_SUCCESS,
				beforeAfterCallback: false
			});
		},
		onSuccessfulSubmitForm() {},
		onTradingAgreementTypeChanged(dataIn) {
			//depending on the tx types allowed for this filed we change transactionTypeList
			this.transactionTypeList = [];

			if (dataIn.allowedTxTypes == "p" || dataIn.allowedTxTypes == "ps") {
				// this.transactionTypeList.push({
				//     value: "Purchase",
				//     tradingWith: "Seller",
				//     label: "Purchase"
				// });
				this.TransactionType = "Purchase";
				this.transactionOtherParty = "Seller";
			}

			if (dataIn.allowedTxTypes == "s" || dataIn.allowedTxTypes == "ps") {
				// this.transactionTypeList.push({
				//     value: "Sale",
				//     tradingWith: "Buyer",
				//     label: "Sale"
				// });
				this.TransactionType = "Sale";
				this.transactionOtherParty = "Buyer";
			}
		},
		onSoldAsChanged(dataIn) {
			//dummy code to stop es lint crying about this
			if (!dataIn) {
				return;
			}
		},
		onMapClickActivated(e) {
			var that = this;
			//    this.Geocoder.query(e.lngLat.lng + "," + e.lngLat.lat);
			var URL =
				"https://nominatim.openstreetmap.org/reverse?format=jsonv2&polygon_geojson=1&lat=" +
					e.lngLat.lat +
					"&lon=" +
					e.lngLat.lng +
					"&zoom=12";

			//latitude;longitude
			this.addressFoundGPS = { lon: e.lngLat.lng, lat: e.lngLat.lat };

			axios({
				method: "GET",
				url: URL
			})
				.then(function(response) {
					that.onNominatimReturn(response.data);
					return response;
				})
				.catch(function() {});
		},
		onNominatimReturn(dataIn) {
			this.addressFound = null;
			this.addressFound = dataIn.display_name;

			this.markLocationOnMap(dataIn.geojson);

			this.Map.flyTo({
				center: turfCenter(dataIn.geojson).geometry.coordinates,
				zoom: 8
			});
		},
		markLocationOnMap(geojson) {
			//First clear off the old layers drawn
			if (this.locationMarker) {
				this.locationMarker.remove();
			}
			if (this.foundAreaMarkerLayerID) {
				this.Map.removeLayer(this.foundAreaMarkerLayerID);
			}

			var layers = this.Map.getStyle().layers;
			// Find the index of the first symbol layer in the map style
			var firstSymbolId;
			for (var i = 0; i < layers.length; i++) {
				if (layers[i].type === "symbol") {
					firstSymbolId = layers[i].id;
					break;
				}
			}

			//If the geojson object is not there then we need to place a marker instead of the layer we added before
			if (geojson && geojson.type == "Point") {
				const mapboxgl = require("mapbox-gl/dist/mapbox-gl");
				var marker = new mapboxgl.Marker();
				marker.setLngLat(geojson.coordinates);
				this.locationMarker = marker.addTo(this.Map);
			} else {
				//create a "unique" name
				this.foundAreaMarkerLayerID = "layer" + Date.now();

				this.Map.addLayer(
					{
						id: this.foundAreaMarkerLayerID,
						type: "fill",
						source: {
							type: "geojson",
							data: geojson
						},
						layout: {},
						paint: {
							"fill-color": "#007f00",
							"fill-opacity": 0.4
						}
					},
					firstSymbolId
				);
			}
		},
		mapInitialized(mapIn) {
			this.initedMap = mapIn;
			this.Geocoder = new MapboxGeocoder({
				accessToken: this.mapOptions.accessToken,
				reverseGeocode: true,
				types: "locality,postcode,place,country,region,postcode,district",
				language: "en",
				limit: 0,
				zoom: 8,
				reverseMode: "distance"
			});

			//Add the geo coder
			mapIn.addControl(this.Geocoder);

			mapIn.on("click", this.onMapClickActivated);

			var that = this;
			//on `result` means, when the user serches and select from the list of location he's shown
			this.Geocoder.on("result", function(rslt) {
				that.addressFound = null;
				that.addressFound = rslt.result.place_name_en;

				that.markLocationOnMap(rslt.result.geometry);

				that.Map.flyTo({
					center: rslt.result.center,
					zoom: 8
				});
			});

			this.Map = mapIn;

			//Dirty hacks for piece of shit components. lol
			var geocoderParentElem = document.getElementsByClassName("mapboxgl-ctrl-geocoder")[0].parentNode;
			geocoderParentElem.style.position = "absolute";
			geocoderParentElem.style.width = "100vw";
			geocoderParentElem.style.right = "37%";
			geocoderParentElem.style.top = "20px";
		},
		//NOP lookup
		searchNOPOperations(searchQry) {
			if (!searchQry) {
				return;
			}
			var URL = this.$store.state.urls.GET_BUYER_BY_OP_NAME + searchQry + "/";
			//figure which method to call, if number its nop, if not, then searching by name
			//need to make a copy of this string
			//doing it like this to get a deep copy of the string so we dont mess it up
			var tmp = ("" + searchQry).replace(/ /g, "");
			if (Number.isInteger(Number(tmp))) {
				URL = this.$store.state.urls.GET_BUYER_BY_OP_NOP_ID + tmp + "/";
			}
			asyncRequest.ServerAPI({
				progressBarObj: this.$Progress,
				method: "GET",
				api: URL,
				onSuccessCallback: dataIn => {
					this.reorganizeOperationsData(dataIn);
				},
				flags: asyncRequest.M_FAIL,
				beforeAfterCallback: false
			});
		},
		reorganizeOperationsData(dataIn) {
			if (!Array.isArray(dataIn.Data)) {
				this.buyersList = [];
				return;
			}

			this.buyersList = [];
			var d = dataIn.Data;
			for (var i = 0; i < d.length; i++) {
				var t = JSON.parse(JSON.stringify(d[i]));

				var l = d[i].NOPID + " : " + d[i].OpName;
				t.opIdNameLabel = l;

				if (d[i].City || d[i].Country) {
					t.countryLabel = " (" + d[i].City + " - " + d[i].Country + ")";
					l += t.countryLabel;
				}

				t.value = d[i].PKUSDANOPID;
				t.label = l;

				this.buyersList.push(t);
			}
		},

		//Product lookup
		findAllProducts() {
			asyncRequest.ServerAPI({
				method: "GET",
				api: this.$store.state.urls.GET_ALL_PRODUCTS,
				onSuccessCallback: dataIn => {
					this.reorganizeProductLookupData(dataIn);
				},
				postData: null,
				flags: asyncRequest.M_FAIL,
				customSuccessMessage: "",
				customErrorMessage: "",
				beforeAfterCallback: false
			});
		},
		reorganizeProductLookupData(dataIn) {
			if (!Array.isArray(dataIn.Data)) {
				this.productLookupOptions = [];
				return;
			}
			this.productLookupOptions = [];
			var d = dataIn.Data;

			for (var i = 0; i < d.length; i++) {
				this.productLookupOptions.push({
					value: d[i].ProductID,
					label: d[i].ProductName
				});
			}
		}
	},
	components: { Mapbox }
};
</script>

<style>
#createTransactionView {
	padding: 5px 3%;
}
#createTransactionView .formPadding {
	padding-top: 38px;
}
#createTransactionView .innerForm label {
	font-size: 12px;
	font-height: 5px;
}
#createTransactionView .innerForm {
	margin-bottom: 5px;
}
#createTransactionView .mapboxgl-canvas {
	position: inherit !important;
}
#createTransactionView #map {
	height: 52vh;
	margin-top: -16px;
}
#createTransactionView .datePickerDiv input {
	border: 1px solid #dae1e7;
	width: 100%;
	height: 100%;
	padding-left: 12px;
	height: 33px;
}
#createTransactionView .mapboxgl-ctrl-geocoder {
	width: 100vw;
}
#createTransactionView .labelSpan {
	font-size: 12px;
	font-style: italic;
	font-weight: 300;
}
</style>
